module.exports = __webpack_public_path__ + "static/media/Sun.e17c9d0e.svg";